import { Outlet } from "react-router-dom";
import { AuthGuardian } from "@app/router/auth-guardian";
import { PushNavigationHost } from "@app/components/push-navigation-host";

export function RootLayout() {
  return (
    <div className="min-h-[var(--app-root-min-height)] bg-background text-foreground">
      <PushNavigationHost />
      <AuthGuardian />
      <Outlet />
    </div>
  );
}
